import React from 'react'
import { Image, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { GrNext } from "react-icons/gr";

const StitchingCentre = () => {
  return (
    <div>
      <p>The stitching centre began as a transformative initiative and a gateway to empowerment and economic independence for women from Denotified tribes.</p>
      <p>At the heart of our mission is the desire to equip these women with valuable skills, enabling them to master the craft of stitching. Through comprehensive training programs, we aspire to build their expertise,
        boost their confidence, and provide them with a platform to showcase their talents.</p>
      <p>By imparting these skills, we aim to open doors for these women to become self-reliant entrepreneurs. Once trained, they will have the opportunity to take on stitching orders, turning their newfound abilities into a sustainable source of income.</p>
      <p>Currently, the centre is being run at the Mandwa basti in Bhopal. </p>


      <Row>
        <Col sm={3}>
          <Image src={require('../../../assets/images/stitching1.jpeg')} alt="" className='w-100 img-fluid' />
        </Col>
        <Col sm={3}>
          <Image src={require('../../../assets/images/stitching2.jpeg')} alt="" className='w-100 img-fluid' />
        </Col>
      </Row>
      {/* <div className='mt-3'>
        <Link to="https://store.muskaan.org/" target='_blank' className='buy-now-btn mt-5'>Shop Now <GrNext /></Link>
      </div> */}
    </div>
  )
}

export default StitchingCentre
